import { useMutation } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useUpdateGardenName() {
  return useMutation(api.gardens.mutations.updateGardenName).withOptimisticUpdate(
    (localStore, { gardenId, name }) => {
      const current = localStore.getQuery(api.gardens.queries.getUserGardens, {});
      if (current === undefined) return;

      localStore.setQuery(
        api.gardens.queries.getUserGardens,
        {},
        current.map((g) => (g._id === gardenId ? { ...g, name } : g))
      );
    }
  );
}
